import script from "./technicalSupport.vue?vue&type=script&setup=true&lang=js"
export * from "./technicalSupport.vue?vue&type=script&setup=true&lang=js"

import "./technicalSupport.vue?vue&type=style&index=0&id=115f3786&scoped=true&lang=less"

import exportComponent from "/workspace/office-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-115f3786"]])

export default __exports__